



































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import * as _ from "lodash";
import {
  GetTopicsOfTemplate,
  GetTemplatesOfGroup,
  GetImportWayCenterList,
} from "@/request/projects";
import { GetUserHospitals } from "@/request/hospitals";
import {
  GetPatientsList as CdrGetPateintsList,
  GetHospitals as CdrGetHospitals,
} from "@/request/cdr";
import {
  GetPatientsList as HdrGetPatientsList,
  GetHospitals as HdrGetHospitals,
} from "@/request/hdr";
import { PostImportHospatients } from "@/request/groups";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import AddPatient from "./add-patient.vue";
import SelectMultiSearch from "./select-multi-search.vue";
import HdrPrimaryFilter from "./hdr-primary-filter.vue";
@Component({
  components: {
    Copy,
    Pagination,
    AddPatient,
    SelectMultiSearch,
    HdrPrimaryFilter,
  },
})
export default class ZbsjkPatientList extends Vue {
  private filters: any = {
    hospital_ids: [],
    范围: [],
    search: "",
    性别: "",
    开始年龄: "",
    结束年龄: "",
    开始时间: "",
    结束时间: "",
    年龄段: [],
    timeWay: "",
    time: [],
    条件: "",
    研究指标: [],
    自定义年龄: [false],
    时间段: "",
    自定义时间段: [false, []],
    currentPage: 1,
    totalPage: 0,
    totalCount: 0,
    pageSize: 10,
    cSortField: "更新时间",
    cSortValue: "0",
    ifPrimarySearched: false,
  };
  private ifLoading: boolean = false;
  // 搜索条件
  private hospitals: any[] = [];
  private saveModel: "add" | "delete" = "add";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private patients: any[] = [];
  // 添加患者
  private ifShowAddPatient: boolean = false;
  private cPatient: any = {};
  // 高级筛选
  private ifShowPrimarySearch: boolean = false;
  private ifShowPrimaryFilter: boolean = false;
  private searchedTemplates: any[] = [];
  @Watch("center", { immediate: true, deep: true })
  private centerChange(e) {
    const localFilters = localStorage.getItem("zbsjkFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        hospital_ids: [],
        范围: [],
        search: "",
        性别: "",
        开始年龄: "",
        结束年龄: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
        cSortField: "更新时间",
        cSortValue: "0",
        ifPrimarySearched: false,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    if (e.project_id) {
      this.fetchPatients().then(() => {
        this.fetchHospitals();
      });
    }
  }
  private setFilters() {
    localStorage.setItem("zbsjkFilters", JSON.stringify(this.filters));
  }
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    let getHospitals$: Promise<any> = new Promise(() => {
      const a = 1;
    });
    switch (this.center["center"]) {
      case "临床科室数据中心":
        getHospitals$ = CdrGetHospitals(this, params);
        break;
      case "治未病数据中心":
        getHospitals$ = HdrGetHospitals(this);
        break;
      case "名中医传承数据中心":
        getHospitals$ = CdrGetHospitals(this, params);
        break;
      case "中医影像数据中心":
        getHospitals$ = HdrGetHospitals(this);
        break;
    }
    getHospitals$.then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
    });
  }
  /**
   * @description 搜索可选的机构
   */
  private searchHospitals(ev) {
    const params: any = {
      params: {
        project_id: this.center.project_id,
        search: ev,
      },
    };
    let getHospitals$: Promise<any> = new Promise(() => {
      const a = 1;
    });
    switch (this.center["center"]) {
      case "临床科室数据中心":
        getHospitals$ = CdrGetHospitals(this, params);
        break;
      case "治未病数据中心":
        getHospitals$ = HdrGetHospitals(this, params);
        break;
      case "名中医传承数据中心":
        getHospitals$ = CdrGetHospitals(this, params);
        break;
      case "中医影像数据中心":
        getHospitals$ = HdrGetHospitals(this, params);
        break;
    }
    getHospitals$.then((data: any) => {
      if (this.filters["范围"].length > 0) {
        data.unshift(this.filters["范围"][0]);
      }
      this.hospitals = _.uniqBy(data, "hospital_id");
    });
  }
  /**
   * @description 移除tag时显示全部医院
   */
  private addAllHospital() {
    if (this.filters["范围"].length === 0) {
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
      this.hospitals = _.uniqBy(this.hospitals, "hospital_id");
    }
  }
  /**
   * @description 添加档案
   */
  private addPatient() {
    this.ifShowAddPatient = true;
  }
  /**
   * @description 处理治未病数据中心高级筛选
   */
  private hdrPrimaryFilterChange(val) {
    this.ifShowPrimaryFilter = false;
    this.$set(this, "filters", val);
    this.filters.currentPage = 1;
    this.saveModel = "delete";
    this.filters.ifPrimarySearched = true;
    this.fetchPatients();
  }
  /**
   * @description 打开高级筛选
   */
  private openPrimarySearch() {
    this.fetchTemplates();
    this.ifShowPrimarySearch = true;
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(
      this,
      this.center.project_id,
      this.center.group_id
    ).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级搜索
   */
  private resetPrimarySearch() {
    switch (this.center["center"]) {
      case "临床科室数据中心":
        this.filters.ifPrimarySearched = false;
        this.ifShowPrimarySearch = false;
        this.filters.timeWay = "";
        this.filters.time = [];
        this.filters["条件"] = "";
        this.filters["研究指标"] = [];
        break;
      case "治未病数据中心":
        this.filters.ifPrimarySearched = false;
        this.filters["开始年龄"] = "";
        this.filters["结束年龄"] = "";
        this.filters["开始时间"] = "";
        this.filters["结束时间"] = "";
        this.filters["年龄段"] = [];
        this.filters["自定义年龄"] = [false];
        this.filters["时间段"] = "";
        this.filters["自定义时间段"] = [false, []];
        this.filters["体重"] = [];
        this.filters["单位"] = "";
        this.filters["备孕女性体质辨识"] = [];
        this.filters["孕期女性体质辨识"] = [];
        this.filters["产后女性体质辨识"] = [];
        this.filters["老年人体质类型"] = [];
        this.filters["儿童体质类型"] = [];
        this.filters["体质辨识"] = [];
        this.filters["四诊合参体质辨识"] = [];
        this.filters["慢性病"] = [];
        break;
      case "名中医传承数据中心":
        this.filters.ifPrimarySearched = false;
        this.ifShowPrimarySearch = false;
        this.filters.timeWay = "";
        this.filters.time = [];
        this.filters["条件"] = "";
        this.filters["研究指标"] = [];
        break;
      case "中医影像数据中心":
        this.filters.ifPrimarySearched = false;
        this.ifShowPrimarySearch = false;
        this.filters.timeWay = "";
        this.filters.time = [];
        this.filters["条件"] = "";
        this.filters["研究指标"] = [];
        break;
    }

    this.search();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.ifShowPrimarySearch = false;
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.ifShowPrimarySearch = false;
    this.filters.currentPage = 1;
    this.saveModel = "delete";
    this.filters.ifPrimarySearched = true;
    this.fetchPatients();
  }
  /**
   * @description 跳转数据导出
   */
  private jumpDataExport() {
    this.$router.push({
      path: "/main/sjzx/zbsjk-data-export",
    });
  }
  /**
   * @description 获取病人列表
   */
  private fetchPatients() {
    return new Promise((resolve, reject) => {
      this.ifLoading = true;
      // hospital_ids
      this.filters.hospital_ids = [];
      this.filters["范围"].forEach((item: any) => {
        this.filters.hospital_ids.push(item["hospital_id"]);
      });
      if (this.filters.hospital_ids.includes("")) {
        this.filters.hospital_ids = [];
      }
      const params: any = {};
      // 处理基本搜索条件
      switch (this.center["center"]) {
        case "临床科室数据中心":
          params["category"] = "临床科室数据中心";
          params["hospital_ids"] = this.filters.hospital_ids;
          params["project_id"] = this.center.project_id;
          params["group_id"] = this.filters.group_id;
          params["order_field"] = this.filters.cSortField;
          params["order_value"] = this.filters.cSortValue;
          params["current_page"] = this.filters.currentPage;
          params["page_count"] = this.filters.pageSize;
          params["search"] = this.filters.search;
          params["性别"] = this.filters["性别"];
          params["条件"] = this.filters["条件"];
          break;
        case "名中医传承数据中心":
          params["category"] = "名中医传承数据中心";
          params["hospital_ids"] = this.filters.hospital_ids;
          params["project_id"] = this.center.project_id;
          params["group_id"] = this.filters.group_id;
          params["order_field"] = this.filters.cSortField;
          params["order_value"] = this.filters.cSortValue;
          params["current_page"] = this.filters.currentPage;
          params["page_count"] = this.filters.pageSize;
          params["search"] = this.filters.search;
          params["性别"] = this.filters["性别"];
          params["条件"] = this.filters["条件"];
          break;
        case "治未病数据中心":
          params["center"] = "治未病数据中心";
          params["hospital_ids"] = this.filters.hospital_ids;
          params["order_field"] = this.filters.cSortField;
          params["order_value"] = this.filters.cSortValue;
          params["current_page"] = this.filters.currentPage;
          params["page_count"] = this.filters.pageSize;
          params["search"] = this.filters.search;
          params["姓名"] = this.filters["search"];
          params["性别"] = this.filters["性别"];
          params["年龄段"] = this.filters["年龄段"];
          params["体重"] = this.filters["体重"];
          params["单位"] = this.filters["单位"];
          params["老年人体质类型"] = this.filters["老年人体质类型"];
          params["儿童体质类型"] = this.filters["儿童体质类型"];
          params["体质辨识"] = this.filters["体质辨识"];
          params["四诊合参体质辨识"] = this.filters["四诊合参体质辨识"];
          params["备孕女性体质辨识"] = this.filters["备孕女性体质辨识"];
          params["孕期女性体质辨识"] = this.filters["孕期女性体质辨识"];
          params["产后女性体质辨识"] = this.filters["产后女性体质辨识"];
          params["慢性病"] = this.filters["慢性病"];
          break;
        case "中医影像数据中心":
          params["center"] = "中医影像数据中心";
          params["hospital_ids"] = this.filters.hospital_ids;
          params["project_id"] = this.center.project_id;
          params["group_id"] = this.filters.group_id;
          params["order_field"] = this.filters.cSortField;
          params["order_value"] = this.filters.cSortValue;
          params["current_page"] = this.filters.currentPage;
          params["page_count"] = this.filters.pageSize;
          params["姓名"] = this.filters.search;
          params["性别"] = this.filters["性别"];
          params["条件"] = this.filters["条件"];
          break;
      }
      // 处理高级筛选
      switch (this.center["center"]) {
        case "临床科室数据中心":
        case "名中医传承数据中心":
        case "中医影像数据中心":
          if (this.filters.timeWay === "自定义") {
            params["开始时间"] = this.filters.time[0];
            params["结束时间"] = this.filters.time[1];
            this.filters.ifPrimarySearched = true;
          }
          if (this.filters["研究指标"].length > 0) {
            this.filters.ifPrimarySearched = true;
            const arr: any[] = [];
            this.filters["研究指标"].map((item: any) => {
              const i = JSON.parse(JSON.stringify(item.selected));
              i.condition = item.result.condition;
              i.value = item.result.value;
              arr.push(i);
            });
            params["研究指标"] = arr;
          }
          break;
        case "治未病数据中心":
          if (this.filters["自定义时间段"][0]) {
            params["开始时间"] = this.filters["自定义时间段"][1][0];
            params["结束时间"] = this.filters["自定义时间段"][1][1];
          }
          break;
      }

      let getPatients$: Promise<any> = new Promise(() => {
        const a = 1;
      });
      switch (this.center["center"]) {
        case "临床科室数据中心":
          getPatients$ = CdrGetPateintsList(this, params);
          break;
        case "治未病数据中心":
          getPatients$ = HdrGetPatientsList(this, params);
          break;
        case "名中医传承数据中心":
          getPatients$ = CdrGetPateintsList(this, params);
          break;
        case "中医影像数据中心":
          getPatients$ = HdrGetPatientsList(this, params);
          break;
      }

      getPatients$
        .then((data: any) => {
          this.patients = data.patients;
          this.filters.totalPage = data.total_page;
          this.filters.totalCount = data.total_count;
          if (this.saveModel === "add") {
            this.checkAllMessages(false);
            this.autoCheckSelectedMessages(true);
          } else {
            this.checkAllMessages(true);
            this.autoCheckSelectedMessages(false);
          }
          const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
          this.checkAll = checkedCount === this.patients.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.patients.length;
          resolve();
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          this.setFilters();
          this.ifLoading = false;
        });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filters.cSortField = ev["prop"];
    this.filters.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  // 勾选
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.patients.forEach((message: any, index: number) => {
      this.$set(this.patients[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.patients.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.patients.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.patients.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.patients.length;
  }
  /**
   * @description 某行被点击
   */
  private rowClicked(row, column, event) {
    switch (this.center["center"]) {
      case "临床科室数据中心":
        this.$router.push({
          path: "/main/cdr/patient-detail",
          query: {
            patient_id: row.patient_id,
            project_id: this.center.project_id,
            group_id: this.center.group_id,
          },
        });
        break;
      case "治未病数据中心":
        this.$router.push({
          path: "/main/hdr/patient-detail",
          query: { patient_id: row.patient_id },
        });
        break;
      case "名中医传承数据中心":
        this.$router.push({
          path: "/main/edr/patient-detail",
          query: {
            patient_id: row.patient_id,
            project_id: this.center.project_id,
            group_id: this.center.group_id,
          },
        });
        break;
      case "中医影像数据中心":
        this.$router.push({
          path: "/main/idr/patient-detail",
          query: { patient_id: row.patient_id },
        });
        break;
    }
  }
}
